.aircraftTableSection {
    display: flex;
    flex-direction: column;
    gap: var(--aircraft-table-section-gap);
    width: 100%;
}

.tableScroll {
    overflow-x: auto;
    width: 100%;
}

.loadMore {
    align-self: center;
}
